import type { SignUpFormData, SignUpPayload } from "~/types/account";

/**
 * Norce body for sign-up. Off the gate it must stay byte-identical to what the
 * other templates sent before gated B2B existed.
 *
 * `IsActive` is deliberately absent: the pending state is enforced server-side,
 * because a client-supplied flag is a client-removable flag.
 */
export const buildSignUpPayload = (
	formData: SignUpFormData,
	b2bAccess: boolean
): SignUpPayload => {
	// `Company` sits in `formData` for Vuelidate only. `agree` is UI-only.
	const { Company, agree, ...customer } = formData;

	if (!b2bAccess) return { ...customer, agree };

	return {
		...customer,
		// No Id ⇒ Norce creates it. InvoiceAddress must be an object.
		Companies: [{ ...Company, InvoiceAddress: customer.InvoiceAddress }]
	};
};
